<!-- src/views/NewsDetail.vue -->
<template>
  <el-main class="news-detail-container w">
    <!-- 返回按钮 -->
    <div class="back-btn">
      <el-button @click="goBack" plain> ← 返回列表 </el-button>
    </div>
    <!-- 加载状态 -->
    <div v-if="loading" class="loading">
      <div class="spinner"></div>
      <p>加载中...</p>
    </div>
    <!-- 新闻内容 -->
    <div v-else class="news-content">
      <h2 class="news-title">{{ news.title }}</h2>
      <!-- <div class="meta">
        <span v-if="news.hot" class="hot-tag">热门</span>
        <span>作者: {{ news.author }}</span>
        <span>阅读量: {{ news.readingVolume }}</span>
        <span>创建时间: {{ news.createTime }}</span>
      </div> -->
      <div class="description" v-html="news.content"></div>
    </div>
  </el-main>
</template>

<script>
import { getNewsDetail, getQuestionDetail } from "@/api/newsApi";

export default {
  data() {
    return {
      loading: true,
      news: {},
      listScrollPosition: 0, // 保存列表页的滚动位置
      listPageInfo: null, // 保存列表页的状态信息
    };
  },
  created() {
    // 从路由参数中获取列表页信息
    if (this.$route.query.scrollPosition) {
      this.listScrollPosition = parseInt(this.$route.query.scrollPosition);
    }

    if (this.$route.query.listState) {
      try {
        this.listPageInfo = JSON.parse(this.$route.query.listState);
      } catch (e) {
        console.error("解析列表状态失败", e);
      }
    }
    this.fetchDetail();
  },
  methods: {
    async fetchDetail() {
      const id = this.$route.params.id;
      const source = this.$route.query.source; // 获取来源标识

      try {
        let response;
        // 根据来源调用不同的接口
        if (source === "questions") {
          // 150问问题详情
          response = await getQuestionDetail(id);
        } else {
          // 普通资讯详情
          response = await getNewsDetail(id);
        }

        if (response.data.code === 200) {
          const data = response.data.data;
          this.news = {
            title: data.title,
            author: data.username || "管理员",
            content: data.content,
            readingVolume: data.readingvolume || data.readingVolume || 0,
            interest: data.interest || 0,
            createTime: data.create_time || data.publishTime || "",
            hot: (data.interest || 0) > 100, // 假设关注量大于100则标记为热门
          };
        } else {
          this.$message.error("获取内容失败：" + response.data.msg);
        }
      } catch (error) {
        this.$message.error("请求失败：" + error.message);
      } finally {
        this.loading = false;
      }
    },
    goBack() {
      const source = this.$route.query.source;
      
      if (source === "questions") {
        // 从150问来的，返回150问列表页
        this.$router.push({
          path: "/questions",
        });
      } else {
        // 返回上一页
        this.$router.back();
      }
    },
    formatDate(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      return date.toLocaleDateString() + " " + date.toLocaleTimeString();
    },
  },
};
</script>

<style scoped>
.w {
  width: 1200px;
  margin: auto;
}
/* 全局字体设置 */
/* body {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
} */
.news-detail-container {
  max-width: 1200px;
  margin: 80px auto;
  padding: 60px; /* 增大内边距，从40px增加到60px */
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
}

/* .spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #007bff;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
} */

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.news-title {
  font-size: 32px;
  color: #1e57e6;
  margin-bottom: 20px;
  line-height: 1.4;
  padding: 0 30px; /* 标题增加左右内边距 */
}

.meta {
  color: #666;
  font-size: 16px;
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 30px; /* 元数据增加左右内边距 */
}

.meta span {
  margin-right: 25px;
  margin-bottom: 8px;
}

.hot-tag {
  background-color: #ff4d4f;
  color: white;
  padding: 4px 10px;
  font-size: 14px;
  border-radius: 4px;
  font-weight: 600;
}

.description {
  font-size: 18px;
  line-height: 2.1;
  white-space: pre-line;
  word-break: break-word;
  color: #444;
  padding: 0 30px; /* 内容增加左右内边距 */
  text-indent: 2em; /* 首行缩进两个汉字宽度 */
}

/* 新增：首行缩进样式 */
.description p {
  text-indent: 2em; /* 首行缩进两个字符 */
  margin-bottom: 16px; /* 段落间距 */
}

.description p:first-child {
  text-indent: 0; /* 标题后第一段不缩进 */
}

/* 响应式设计 - 在小屏幕上减少内边距 */
@media (max-width: 768px) {
  .news-detail-container {
    padding: 30px; /* 在小屏幕上减少内边距 */
    margin: 40px auto;
  }

  .news-title,
  .meta,
  .description {
    padding: 0 15px; /* 在小屏幕上减少左右内边距 */
  }
}
/* 返回键 */
.back-btn {
  margin-top: 1px;
  margin-bottom: 20px;
  text-align: left;
}

/* .el-button--plain {
  background-color: #f5f7fa;
  color: #333;
  border: none;
  font-weight: bold;
}

.el-button--plain:hover {
  background-color: #e9e9e9;
} */
.el-button--plain {
  /* 放大字体 */
  font-size: 18px; /* 增加字体大小 */
  /* 设置蓝色文字 */
  color: #1e90ff; /* 蓝色文字 */
  /* 设置背景色 */
  background-color: #f5f7fa;
  border: none;
  font-weight: bold;
  /* 增加内边距使按钮更大 */
  padding: 10px 20px;
}

.el-button--plain:hover {
  /* 悬停时的背景色 */
  background-color: #e6f2ff; /* 浅蓝色背景 */
  /* 悬停时的文字颜色（可选） */
  color: #005cb3; /* 更深的蓝色文字 */
}
</style>
<!-- <style scoped>
.news-detail-container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 30px 20px;
}

.back-btn {
  margin-bottom: 25px;
}

.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.news-content {
  background-color: white;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
}

.news-title {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #1e57e6;
}

.meta {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 25px;
  color: #666;
  font-size: 14px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.hot-tag {
  background-color: #ff4d4f;
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.description {
  line-height: 1.8;
  font-size: 16px;
  color: #333;
}

.description >>> img {
  max-width: 100%;
  height: auto;
  margin: 15px 0;
  border-radius: 8px;
}

.description >>> p {
  margin-bottom: 15px;
}

.description >>> h2,
.description >>> h3 {
  color: #1e57e6;
  margin: 20px 0 10px;
}

.description >>> a {
  color: #1e57e6;
  text-decoration: underline;
}

@media (max-width: 768px) {
  .news-detail-container {
    padding: 20px 15px;
  }

  .news-content {
    padding: 20px;
  }

  .news-title {
    font-size: 24px;
  }

  .meta {
    flex-direction: column;
    gap: 8px;
  }
}
</style> -->
